import { render, staticRenderFns } from "./ClientUsersList.vue?vue&type=template&id=13d41800"
import script from "./ClientUsersList.vue?vue&type=script&lang=js"
export * from "./ClientUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports